/* unplugin-vue-components disabled */import script from "./YtbAccessDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./YtbAccessDialog.vue?vue&type=script&setup=true&lang=js"

import "./YtbAccessDialog.vue?vue&type=style&index=0&id=6cef14d9&scoped=true&lang=css"
import "./YtbAccessDialog.vue?vue&type=style&index=1&id=6cef14d9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cef14d9"]])

export default __exports__